import { useLocation } from 'react-router-dom'
import AppSidebar from './AppSidebar.tsx'

export default function AppSidebarOutlet() {
  const { pathname } = useLocation()

  let sidebar = null

  switch (pathname) {
    default:
      sidebar = <AppSidebar />
  }

  return <>{sidebar}</>
}
